export default {
  bovespa: 'Ação na bovespa',
  volume: 'Volume',
  price: 'Preço',
  mentions: 'Menções',
};
